import { render } from "./BreadcrumbsSite.vue?vue&type=template&id=8e5c2b30&scoped=true"
import script from "./BreadcrumbsSite.vue?vue&type=script&lang=js"
export * from "./BreadcrumbsSite.vue?vue&type=script&lang=js"

import "./BreadcrumbsSite.vue?vue&type=style&index=0&id=8e5c2b30&scoped=true&lang=scss"

import exportComponent from "C:\\flexites\\1lombard\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8e5c2b30"]])

export default __exports__